import { Button, Stack, type Theme, Typography } from '@mui/material';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';

const RegistryBarbecho = ({
    onRecommendHerbicide,
    onRegisterApplication,
}: {
    onRecommendHerbicide: () => void;
    onRegisterApplication: () => void;
}) => {
    return (
        <Stack
            alignItems='center'
            justifyContent='center'
            spacing={2}
            sx={{ backgroundColor: 'grey.100', border: 1, borderColor: 'primary.mui.stroke', borderRadius: 2, p: 4 }}
        >
            <Icon
                type='fields2'
                sx={{
                    width: 36,
                    height: 36,
                    '& svg *': {
                        fill: (t: Theme) => `${t.palette.primary.main} !important`,
                        fillOpacity: '1 !important',
                    },
                }}
            />
            <Stack alignItems='center' spacing={1} sx={{ px: 3, textAlign: 'center' }}>
                <Typography variant='subtitle1' fontWeight='bold' color='primary'>
                    {_('Manejo de barbecho químico')}
                </Typography>
                <Typography variant='body2' color='primary'>
                    {_(
                        'Registrá los herbicidas aplicados. Lo que cargues queda en el reporte final de la campaña y suma al historial del lote.'
                    )}
                </Typography>
            </Stack>
            <Stack direction='row' spacing={1}>
                <Button variant='outlined' sx={{ background: 'white' }} color='primary' onClick={onRecommendHerbicide}>
                    {_('Recomendar herbicida')}
                </Button>
                <Button variant='contained' color='primary' onClick={onRegisterApplication}>
                    {_('Registrar aplicación')}
                </Button>
            </Stack>
        </Stack>
    );
};

export default RegistryBarbecho;
